import React from 'react';
import { HelpCircle, X } from 'lucide-react';
import { useTour } from '../../contexts/TourContext';

export default function TourPrompt() {
  const { showTourPrompt, startTour, dismissTourPrompt } = useTour();

  if (!showTourPrompt) return null;

  return (
    <div className="fixed bottom-6 right-6 bg-white rounded-lg shadow-lg p-4 max-w-xs z-50 border border-primary-100 animate-fadeIn">
      <button 
        onClick={dismissTourPrompt}
        className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
        aria-label="Dismiss tour prompt"
      >
        <X className="h-4 w-4" />
      </button>
      
      <div className="flex items-start gap-3 mb-3">
        <div className="bg-primary-100 p-2 rounded-full flex-shrink-0">
          <HelpCircle className="h-5 w-5 text-primary-600" />
        </div>
        <div>
          <h3 className="font-semibold text-gray-800 mb-1">New to Blooma?</h3>
          <p className="text-sm text-gray-600">Would you like a quick tour of our features to help you get started?</p>
        </div>
      </div>
      
      <div className="flex justify-end gap-2">
        <button
          onClick={dismissTourPrompt}
          className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800"
        >
          Skip
        </button>
        <button
          onClick={startTour}
          className="px-3 py-1.5 text-sm bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors"
        >
          Take the Tour
        </button>
      </div>
    </div>
  );
}